// GENERATED by frontend/scripts/build-hans-acker-data.mjs -- do not edit by hand.
// Source: panorama360-backend_6e97. Bearer tokens are redacted.
import type { HansAckerFindingDoc } from './types';

export const PANORAMA_FINDING_DOCS: Record<string, HansAckerFindingDoc> = {
  "gap-0001": {
    "title": "Repository mapping / architecture",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Repository mapping / architecture"
      ],
      [
        "Surface",
        "panorama360-backend source tree"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "Workspace path `/workspace/panorama360-backend` contained no visible files during this run; directory listing returned empty/no output, so code mapping deferred.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0002": {
    "title": "Route inventory / handlers",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Route inventory / handlers"
      ],
      [
        "Surface",
        "HTTP/API endpoints (routes)"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "No code available; could not identify any routes or handlers. Will enumerate once repository files are present.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0003": {
    "title": "Authentication / Authorization controls",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Authentication / Authorization controls"
      ],
      [
        "Surface",
        "Auth middleware/guards and RBAC enforcement"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "No auth-related source files present in workspace at path; mapping postponed until code appears.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0004": {
    "title": "Sinks (DB/FS/HTTP/XML)",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Sinks (DB/FS/HTTP/XML)"
      ],
      [
        "Surface",
        "Data access layer, file IO, outbound HTTP clients, XML parsers"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "No source code available to inspect; sinks to be cataloged when code is accessible.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0005": {
    "title": "Repository architecture and route mapping",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Repository architecture and route mapping"
      ],
      [
        "Surface",
        "/workspace/panorama360-backend"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "Workspace repository path `/workspace/panorama360-backend` currently empty; route inventory cannot be derived until code is present.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0006": {
    "title": "Static SAST / Semgrep + AST-grep coverage",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Static SAST / Semgrep + AST-grep coverage"
      ],
      [
        "Surface",
        "/workspace/panorama360-backend (repo root)"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "Repository directory not found at /workspace/panorama360-backend; could not run tools. Requires repository checkout present to proceed.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0007": {
    "title": "Secrets scanning (gitleaks/trufflehog)",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Secrets scanning (gitleaks/trufflehog)"
      ],
      [
        "Surface",
        "/workspace/panorama360-backend (repo root)"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "Repository directory not found at /workspace/panorama360-backend; gitleaks/trufflehog could not execute. Requires repo files.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0008": {
    "title": "Dependency & misconfiguration scanning (trivy fs)",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Dependency & misconfiguration scanning (trivy fs)"
      ],
      [
        "Surface",
        "/workspace/panorama360-backend (repo root)"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "Repository directory not found at /workspace/panorama360-backend; trivy fs not run.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  },
  "gap-0009": {
    "title": "Run/build feasibility",
    "meta": [
      [
        "Status",
        "Needs follow-up"
      ],
      [
        "Risk area",
        "Run/build feasibility"
      ],
      [
        "Surface",
        "/workspace/panorama360-backend local run"
      ],
      [
        "Found",
        "2026-10-14 07:22:35 UTC"
      ]
    ],
    "sections": {
      "Description": "Repository directory exists but contains no files yet; build/run steps blocked pending code presence.",
      "Remediation": "Populate the repository into the scan workspace and re-run the assessment."
    }
  }
};
